module.exports = __webpack_public_path__ + "img/martin.f597f494.svg";